import { SxProps } from '@mui/material';

export const topContennt: SxProps = {
  height: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
};
export const sysName: SxProps = {
  display: 'inline-block',
  color: 'primary.contrastText',
  height: '100%',
  width: 240,
  cursor: 'pointer',
  overflow: 'hidden',
};
export const sysNameText: SxProps = {
  width: 1,
  textAlign: 'center',
  lineHeight: '56px',
  overflow: 'hidden',
};
export const version: SxProps = {
  display: 'none',
  color: 'primary.contrastText',
};
export const company: SxProps = {
  color: 'primary.contrastText',
  paddingLeft: 1,
};

export const carousel: SxProps = {
  height: 30,
  width: 600,
};
export const carouselMsg: SxProps = {
  display: 'inline-block',
  color: 'primary.contrastText',
  minWidth: 600,
  lineHeight: '30px',
  cursor: 'pointer',
};
